import type { VisibleNavigationEntry } from '@Guidelines/Shell/AppShell/Hooks/useVisibleNavigationMenu';
import navChipStyle from '@Guidelines/Shell/AppShell/AppHeader/PrimaryNav/Shared/navChipStyle';
import type * as React from 'react';
import { Link } from 'react-router-dom';

type Props = {
	readonly item: VisibleNavigationEntry;
	readonly isActive: boolean;
};

/** One top-bar entry, linking to the entry's first accessible destination. */
const PrimaryNavEntry: React.FC<Props> = ({ item, isActive }) => {
	return (
		<Link
			to={item.href}
			css={[navChipStyle.chip, isActive ? navChipStyle.active : null]}
			aria-current={isActive ? 'page' : undefined}
		>
			{item.entry.label}
		</Link>
	);
};

export default PrimaryNavEntry;
